import { Injectable, ErrorHandler, Injector } from '@angular/core';
import { AppInsightsService } from './app-insights.service';

@Injectable()
export class AppInsightsErrorHandlerService extends ErrorHandler {
  constructor(private injector: Injector) {
    super();
  }
  
  handleError(error: any): void {
    try {
      const appInsightsSvc = this.injector.get(AppInsightsService);
      
      if (appInsightsSvc && typeof appInsightsSvc.logError === 'function') {
        appInsightsSvc.logError(error);
      }
      console.error('Angular Error:', error);
    } catch (handlerError) {
      console.error('Error in error handler:', handlerError);
      console.error('Original error:', error);
    } finally {
      super.handleError(error);
    }
  }
}